import { LogoVariant } from '@/types/product-pages';
import Image from 'next/image';
import Link from 'next/link';

interface LogoProps {
  variant: LogoVariant;
  href?: string;
  className?: string;
}

export function Logo({ variant, href = '/', className }: LogoProps) {
  const logoConfig = {
    TAGCAIXA: {
      src: '/tagcaixa-empresas-horizontal.png',
      width: 249,
      height: 32,
    },
    ALIMENTACAO: {
      src: '/caixa-alimentacao-horizontal.png',
      width: 267,
      height: 40,
    },
    REFEICAO: {
      src: '/caixa-refeicao-horizontal.png',
      width: 220,
      height: 40,
    },
    MULTI: {
      src: '/caixa-multi-horizontal.png',
      width: 200,
      height: 40,
    },
    VTCAIXA: {
      src: '/caixa-vt-horizontal.png',
      width: 140,
      height: 28,
    },
    FROTACAIXA: {
      src: '/caixa-frota-horizontal.png',
      width: 158,
      height: 26,
    },
    DESPESACAIXA: {
      src: '/caixa-despesa-horizontal.png',
      width: 174,
      height: 26,
    },
    default: {
      src: '/caixa-prepagos-horizontal.png',
      width: 167,
      height: 40,
    },
  };

  const config = logoConfig[variant];

  return (
    <Link href={href} className={className}>
      <Image
        src={config.src}
        alt="CAIXA Pré-Pagos"
        width={config.width}
        height={config.height}
        style={{ height: 'auto' }}
        priority={false}
      />
    </Link>
  );
}
